import { AgencyService } from './../api/agency.service';
import { Component, OnInit, Injector, Inject, ViewChild } from '@angular/core';
import { GoogleMapComponent } from '../gmaps/google-map/google-map.component';
import { BaseComponent } from './base-component';
import { GmapsTravelMode } from '../gmaps/gmaps-interface/gmaps-travel-mode.model';

@Component({
  selector: 'app-contact-base',
  template: ''
})

export class ContactBaseComponent extends BaseComponent implements OnInit {
  @ViewChild(GoogleMapComponent) googleMap: GoogleMapComponent;
  public travelModes: GmapsTravelMode[] = [];

  constructor(
    injector: Injector,
    public agencyService: AgencyService,
    @Inject('WINDOW') public window: any
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.setTitle('Contact ' + this.agencyService.agency.name);
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/contact-base.component.ts